const LANDING_PAGE_URL = {
  CREATE_ACCOUNT: (companyCode = '') =>
    `${process.env.REACT_APP_LDP_URL}/create-account${
      companyCode ? `?code=${companyCode}` : ''
    }`,
  REGISTER: `${process.env.REACT_APP_LDP_URL}/request-register`,
  POLICY: `${process.env.REACT_APP_LDP_URL}/privacy-policy`,
  EMISSION_POLICY:
    'https://www.env.go.jp/earth/ondanka/supply_chain/gvc/files/tools/unit_outline_V3-4.pdf',
  EMISSION_POLICY_DATA_SOURCE: '/emission-policy/data-source',
}

export { LANDING_PAGE_URL }
